import React from 'react';

const SalesTaxSectionLayout = ({
  title,
  children,
  renderHeader = () => null,
}: {
  children: React.ReactNode;
  title?: string;
  renderHeader?: () => React.ReactNode;
}) => {
  return (
    <div className="flex flex-col gap-6 max-w-[720px]">
      {renderHeader && renderHeader()}
      {children}
    </div>
  );
};

export default SalesTaxSectionLayout;
